import { render, staticRenderFns } from "./ContactInformationOtherParty.vue?vue&type=template&id=219b737e"
import script from "./ContactInformationOtherParty.vue?vue&type=script&lang=ts"
export * from "./ContactInformationOtherParty.vue?vue&type=script&lang=ts"
import style0 from "./ContactInformationOtherParty.vue?vue&type=style&index=0&id=219b737e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports